import { render } from "./InfoRowDetailsSymptomReport.vue?vue&type=template&id=67666c54&scoped=true"
import script from "./InfoRowDetailsSymptomReport.vue?vue&type=script&lang=js"
export * from "./InfoRowDetailsSymptomReport.vue?vue&type=script&lang=js"

import "./InfoRowDetailsSymptomReport.vue?vue&type=style&index=0&id=67666c54&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67666c54"]])

export default __exports__